/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * @Description This is a wrapper for "Checkbox" component
 * @FileName fasatCheckbox.js
 * @Author SAMAPTI TALUKDAR-talusam
 * @CreatedOn 18 February, 2021 05:49:30
 * @IssueID CDTFASATMOD- 570
 */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@manulife/mux';
import FasatLabel from '../fasatLabel/fasatLabel';
import './fasatCheckbox.scss';
import FasatFormErrors from '../fasatFormErrors/fasatFormErrors';

const renderSec = ({ extRenderCheckbox, id, labelText, val1, val2 }) => (
  <FasatLabel htmlFor={id} isContent>
    {extRenderCheckbox ? (
      <>
        {labelText}
        {val1}
      </>
    ) : (
      <>
        {labelText}
        {val2}
      </>
    ) }
  </FasatLabel>
);

function FasatCheckbox(props) {
  const { labelText, name, errors, id, className, defaultChecked, isCustom, extRenderCheckbox, cItem, value } = props;
  const { onHandleChange, ...rest } = props;
  const inputClass = `fasatCheckbox ${className}`;
  const fasatInputErrorClass = 'withError';
  const [checkValue, setCheckValue] = useState(defaultChecked);
  const val1 = (
    <span className="indicator"> *</span>
  );
  const val2 = (
    <span className="indicator"> #</span>
  );

  const changeHandler = useCallback((val) => onHandleChange(val));
  useEffect(() => {
    setCheckValue(defaultChecked);
  }, [defaultChecked]);

  /**
   * CONTROLLED COMPONENT IMPLEMENTATION:
   * - Use 'value' prop for controlled checkbox behavior (recommended for form state management)
   * - The 'value' prop will be passed as 'checked' to the MUX Checkbox component
   * - When using 'value' prop, do NOT use 'defaultChecked' together as they serve different purposes
   * - 'defaultChecked' is for uncontrolled components and will be ignored when 'value' is provided
   * - If 'value' is not provided, component falls back to uncontrolled behavior
   */
  const muxCheckboxProps = { ...rest };
  const checkedValue = value !== undefined && value !== null;
  if (checkedValue !== undefined) {
    muxCheckboxProps.checked = value;
  }

  const renderCheckBox = () => (
    <div
      className={`${inputClass} ${
        errors.length > 0 && errors[0].isError ? fasatInputErrorClass : ''
      }`}
    >
      {!isCustom && (
      <Checkbox
        {...muxCheckboxProps}
        onChange={changeHandler}
      />
      )}

      {isCustom && (
      <input
        {...rest}
        type="checkbox"
        onChange={(e) => onHandleChange(e.target.checked)}
        checked={checkValue}
        className="sdCheckbox"
      />
      )}
      {!extRenderCheckbox && (cItem.resourceName !== 'RBAC_REPORTS')
        ? (
          <FasatLabel htmlFor={id} isContent>
            {labelText}
          </FasatLabel>
        )
        : renderSec(({ extRenderCheckbox, id, labelText, val1, val2 }))}
      <FasatFormErrors name={name} errors={errors} />
    </div>
  );
  return (
    <>
      {renderCheckBox()}
    </>
  );
}

FasatCheckbox.propTypes = {
  labelText: PropTypes.string,
  onHandleChange: PropTypes.func,
  errors: PropTypes.shape(),
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  isCustom: PropTypes.bool,
  extRenderCheckbox: PropTypes.bool,
  cItem: PropTypes.shape(),
  value: PropTypes.bool,
};

FasatCheckbox.defaultProps = {
  labelText: '',
  onHandleChange: () => undefined,
  errors: [],
  name: '',
  id: '',
  className: '',
  defaultChecked: 0,
  isCustom: false,
  extRenderCheckbox: false,
  cItem: {},
  value: undefined,
};

export default FasatCheckbox;
